export const extractMediaUrl = (value?: string | null): string | undefined => {
  if (!value) {
    return undefined;
  }

  const srcMatch = value.match(/src=["']([^"']+)["']/i);
  return (srcMatch?.[1] || value).replace(/&amp;/g, "&").trim() || undefined;
};

export const getVkVideoErrorMessage = (
  error: unknown,
  fallbackMessage: string
): string => {
  const responseMessage =
    typeof error === "object" && error !== null && "response" in error
      ? (error as { response?: { data?: unknown } }).response?.data
      : undefined;

  if (typeof responseMessage === "string" && responseMessage) {
    return responseMessage;
  }

  if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as { message?: unknown }).message === "string"
  ) {
    return (error as { message: string }).message;
  }

  return fallbackMessage;
};
